module.exports = __webpack_public_path__ + "static/media/04__CALCINHA_LATERAL_DRAPEADA_ESTAMPADA_02.4fe648c3.jpg";